import React from 'react';


const GearLoader = () => (
  <div className="loader">
    <div className="loaderImage"/> 
    {/* <div className="loadingText">Loading...</div> */}
  </div>
);

export default GearLoader;

